import React, { useRef, useState, useEffect, useContext } from 'react';
import useOnScreen from '../../../hooks/useOnScreen';
import { useNavigate } from 'react-router-dom';
import { FilterContext } from '../../../context/FilterContext';

function Category({ data, index = 0 }) {
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  const isVisible = useOnScreen(ref);
  const navigate = useNavigate();
  const fi = useContext(FilterContext);

  useEffect(() => {
    if (isVisible && !show) setShow(true);
  }, [isVisible]);

  const handleClick = () => {
    if (data.nombre !== 'Ver todas') {
      fi.dispatch({
        type: 'set_aplicaciones_filter',
        payload: { aplicaciones: [data.id] },
      });
    } else {
      fi.dispatch({
        type: 'set_aplicaciones_filter',
        payload: { aplicaciones: [] },
      });
    }
    navigate('/productos');
  };

  return (
    <button
      ref={ref}
      onClick={handleClick}
      style={{ transitionDelay: `${(index % 5) * 80}ms` }}
      className={`group block text-left transition-all duration-700 ease-out ${
        show ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      }`}
    >
      <div className="relative overflow-hidden rounded-2xl bg-ink-100">
        <div className="aspect-[4/5] w-full">
          <img
            src={require(`../../../assets/images/categories/${data.imagen}`)}
            alt={data.nombre}
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent opacity-80 transition-opacity duration-300 group-hover:opacity-100" />
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between p-4">
          <span className="font-medium text-white drop-shadow-sm">
            {data.nombre}
          </span>
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white/15 text-white backdrop-blur-sm transition-all duration-300 group-hover:bg-brand-400 group-hover:text-ink">
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        </div>
      </div>
    </button>
  );
}

export default Category;
